import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HeroUIProvider } from "@heroui/react";
import { Provider } from "react-redux";
import store from "./redux/store";
import ErrorBoundary from "./components/Reusable/ErrorBoundary";
// import { toast } from "sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 1000 * 60 * 1, // Data is considered fresh for 1 minute
      cacheTime: 1000 * 60 * 1, // Maintain in cache for 1 minute even if unused
    },
  },
});

// Suppress ResizeObserver loop errors in capture phase before Webpack Dev Server overlay catches it
// window.addEventListener(
//   "error",
//   (e) => {
//     const msg = e?.message || e?.error?.message;
//     if (
//       typeof msg === "string" &&
//       (msg.includes(
//         "ResizeObserver loop completed with undelivered notifications",
//       ) ||
//         msg.includes("ResizeObserver loop limit exceeded"))
//     ) {
//       e.stopImmediatePropagation();
//       e.stopPropagation();
//       e.preventDefault();
//       return true;
//     }
//   },
//   true, // capture phase
// );

// // Global safety measure to prevent ".trim is not a function" errors for numbers
// if (!Number.prototype.trim) {
//   // eslint-disable-next-line no-extend-native
//   Number.prototype.trim = function () {
//     return this.toString().trim();
//   };
// }

// // Global unhandled error handlers
// window.onerror = function (message, source, lineno, colno, error) {
//   // Suppress ResizeObserver loop limit exceeded error which is often benign
//   // and occurs during layout transitions in libraries like NextUI/Radix UI
//   if (
//     message ===
//       "ResizeObserver loop completed with undelivered notifications." ||
//     message === "ResizeObserver loop limit exceeded"
//   ) {
//     return true;
//   }

//   console.error("Global Error:", error);
//   // Errors that break the UI will be caught by ErrorBoundary,
//   // but we can log them or show a toast for background errors
//   return false;
// };

// window.onunhandledrejection = function (event) {
//   console.error("Unhandled Rejection:", event.reason);
//   toast.error("An unexpected background error occurred", {
//     description:
//       event.reason?.message || "Please check your network or refresh.",
//     id: "global-rejection",
//   });
// };

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <HeroUIProvider>
          <App />
        </HeroUIProvider>
      </QueryClientProvider>
    </Provider>
  </ErrorBoundary>,
);
